import { Typography } from "@graphy/ui";
import SectionHeading, { SectionHeadingType } from "../atoms/SectionHeading";
import { CaptionWithImg } from "../molecules/CaptionWithImg";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

export type homeBottomBannerPropsType = {
  title: SectionHeadingType;
  description: string;
  ctas: CtaType[];
  features: {
    feature: string;
    image: string;
  }[];
};

export const HomeBottomBanner = ({
  title,
  description,
  ctas,
  features,
}: homeBottomBannerPropsType) => {
  return (
    <div className="relative">
      {/* PS: Adding these gradients creates janking in hero section */}
      {/* <BgSectionGradientGridLeft className="pointer-events-none absolute left-0 top-0 -z-0 opacity-50 mix-blend-multiply" />
      <BgSectionGradientGridRight className="pointer-events-none absolute bottom-0 right-0 -z-0 opacity-50 mix-blend-multiply" /> */}
      <div className="flex flex-col items-center justify-center bg-grey-1 px-6 py-4 text-center md:px-0 md:py-12">
        <SectionHeading heading={title} key={"home-bottom-banner-heading"} />
        <Typography size="BODY" className="mb-8 mt-1 text-grey-4">
          {description}
        </Typography>
        <div className="flex flex-col-reverse md:flex-col">
          <div className="flex justify-center gap-3">
            <CtaButtonGroup ctas={ctas} />
          </div>
          {features && (
            <div className="mb-3 flex flex-wrap justify-center gap-x-3 md:mb-0 md:mt-4 md:gap-8">
              {features.map((feature) => (
                <CaptionWithImg
                  key={feature.feature + "bottom-banner"}
                  imgSrc={feature.image}
                  caption={feature.feature}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
